import { Carousel } from 'antd';
import { ReactElement } from 'react';

export interface ITestimonials {
  extraClasses?: string;
}

export default function Testimonials({
  extraClasses = '',
}: ITestimonials): ReactElement {
  return (
    <div className={`max-w-3xl mx-auto ${extraClasses}`}>
      <h3 className="text-3xl text-center pb-8">Reviews</h3>
      <Carousel autoplay dots={false} lazyLoad="progressive">
        <div className="flex flex-col justify-center items-center">
          <blockquote className="text-xl">
            “I have been using your service for couple of years and am happy
            with your service and the fees.”
            <footer>
              — <cite className="author">Bob Y.</cite>,{' '}
            </footer>
          </blockquote>
        </div>
        <div className="flex flex-col justify-center items-center">
          <blockquote className="text-xl">
            “Thank you so much! We love using you to park. Best option at DIA!”
            <footer>
              — <cite className="author">Alex N.</cite>,{' '}
            </footer>
          </blockquote>
        </div>
        <div className="flex flex-col justify-center items-center">
          <blockquote className="text-xl">
            “Thank you. I appreciate the good customer service and will continue
            to use your service.”
            <footer>
              — <cite className="author text-lg">Lauralee A.</cite>,{' '}
            </footer>
          </blockquote>
        </div>
      </Carousel>
    </div>
  );
}
